import { render } from "./ResumeSection.vue?vue&type=template&id=cb8b2920&scoped=true"
import script from "./ResumeSection.vue?vue&type=script&lang=js"
export * from "./ResumeSection.vue?vue&type=script&lang=js"

import "./ResumeSection.vue?vue&type=style&index=0&id=cb8b2920&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb8b2920"]])

export default __exports__